var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"300px"}},[(_vm.phone)?_c('a-table-f-api',{attrs:{"api":_vm.api,"model":_vm.model,"searchable":false,"defaults":{ filters: { phone: _vm.phone } }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }